class NotifyDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#NotifyDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderNotifyIconAccessibility();
  }

  setHeaderNotifyIconAccessibility() {
    const notifyTriggers = document.querySelectorAll('[data-notify-drawer-trigger]');
    
    notifyTriggers.forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
   
    // 애니메이션이 항상 트리거되도록 timeout 사용
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('NotifyDrawer');
        const focusElement = this.querySelector('.notify-drawer__inner') || this.querySelector('.notify-drawer__close');
        if (typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('notify-drawer', NotifyDrawer);

// 전역 함수로 drawer 열기
window.openNotifyDrawer = function() {
  const drawer = document.querySelector('notify-drawer');
  if (drawer) {
    drawer.open();
  }
};

// 전역 함수로 drawer 닫기
window.closeNotifyDrawer = function() {
  const drawer = document.querySelector('notify-drawer');
  if (drawer) {
    drawer.close();
  }
};